import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100/80 text-accent-700 text-xs font-semibold rounded-full mb-3">
            平台优势
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            为什么选择豆花视频
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 max-w-4xl mx-auto">
          {featuresData.map((feature, i) => (
            <div
              key={i}
              className="group text-center p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/60 hover:border-accent-200 transition-all duration-200"
            >
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-accent-100/60 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-200 mb-5">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-2.5">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}